import type { MaterialType, PlannerProject, WardrobeModule } from "../types";
import { decorLabel, decorPriceMaterial, resolveDecor } from "./decors";
import { eggerDecor } from "./eggerDecors";

/**
 * Задняя стенка в своём декоре: корпус под дерево, фасад стекло, задник
 * чёрный — так часто собирают витрины. Нет своего декора — задник как корпус.
 */

/** Популярные декоры для задника — быстрый выбор без каталога. */
export const BACK_DECOR_SUGGESTIONS = ["U999 ST19", "U961 ST7", "W1000 ST9", "H1145 ST10"] as const;

export const supportsBackDecor = (module: Pick<WardrobeModule, "type">) =>
  module.type === "shelving" || module.type === "single" || module.type === "double" || module.type === "mezzanine";

export const normalizeBackDecor = (module: Pick<WardrobeModule, "type" | "backDecor">) =>
  supportsBackDecor(module) && eggerDecor(module.backDecor) ? eggerDecor(module.backDecor)!.code : undefined;

export const hasOwnBackDecor = (module: Pick<WardrobeModule, "type" | "backDecor">) =>
  Boolean(normalizeBackDecor(module));

/** У стеллажа задняя стенка есть не всегда: общая или в отдельных ячейках. */
export const shelvingHasBackPanels = (module: WardrobeModule) =>
  module.type !== "shelving" || Boolean(module.shelvingBackPanel) ||
  (module.shelvingCells ?? []).some(cell => cell.backPanel);

/** Декор задней стенки изделия. */
export const backPanelDecor = (project: Pick<PlannerProject, "carcassDecor" | "carcassMaterial">, module: WardrobeModule) =>
  resolveDecor(normalizeBackDecor(module) ?? module.decor ?? project.carcassDecor, module.material ?? project.carcassMaterial);

/** Материал для цены задника. */
export const backPanelMaterial = (project: Pick<PlannerProject, "carcassMaterial">, module: WardrobeModule): MaterialType =>
  hasOwnBackDecor(module) ? decorPriceMaterial(module.backDecor) : module.material ?? project.carcassMaterial;

/** Подпись для техкарты: «Чёрный · U999 ST19 · свой декор» или «в декоре корпуса». */
export const backPanelDescription = (project: Pick<PlannerProject, "carcassDecor" | "carcassMaterial">, module: WardrobeModule) =>
  hasOwnBackDecor(module)
    ? `${decorLabel(backPanelDecor(project, module))} · свой декор задника`
    : `в декоре корпуса (${decorLabel(backPanelDecor(project, module))})`;
